import Navigation from './Navigation'
import navigationContainer from './navigationContainer'

export default navigationContainer(Navigation)
